
import React, { Component } from 'react'


const slider = React.createRef();
const container = React.createRef();
const isTouchDevice = 'ontouchstart' in document.documentElement

export default class SwipeableButton extends Component {

    state = {}

    componentDidMount() {


        if (isTouchDevice) {
            window.addEventListener('touchmove', this.onDrag);
            window.addEventListener('touchend', this.stopDrag);
        } else {
            window.addEventListener('mousemove', this.onDrag);
            window.addEventListener('mouseup', this.stopDrag);
        }
        this.containerWidth = container.current.clientWidth - 50;


    }


    onDrag = e => {


        if (this.unmounted || this.state.unlocked) return;
        if (this.isDragging) {
            if (isTouchDevice) {
                this.sliderLeft = Math.min(Math.max(0, e.touches[0].clientX - this.startX), this.containerWidth);
            } else {

                this.sliderLeft = Math.min(Math.max(0, e.clientX - this.startX), this.containerWidth);
            }
            this.updateSliderStyle();
        }
    }

    updateSliderStyle = () => {


        if (this.props.block != true) {
            if (this.unmounted || this.state.unlocked) return;
            slider.current.style.left = (this.sliderLeft + 50) + 'px';
        }

    }

    stopDrag = () => {
        if (this.unmounted || this.state.unlocked) return;
        if (this.isDragging) {
            this.isDragging = false;
            if (this.sliderLeft > this.containerWidth * 0.9) {
                this.sliderLeft = this.containerWidth;
                if (this.props.onSuccess) {
                    this.props.onSuccess();
                    this.onSuccess();
                }
            } else {
                this.sliderLeft = 0;
                if (this.props.onFailure) {
                    this.props.onFailure();
                }
            }
            this.updateSliderStyle();
        }
    }

    startDrag = e => {

        if (this.props.block) {
            if (this.props.onValdating)
                this.props.onValdating();

        }
        if (this.unmounted || this.state.unlocked) {
            return;
        }
        this.isDragging = true;
        if (isTouchDevice) {
            this.startX = e.touches[0].clientX;
        } else {
            this.startX = e.clientX;
        }
    }



    onSuccess = () => {
        container.current.style.width = container.current.clientWidth + '%';
        this.setState({
            unlocked: true
        })
    }

    getText = () => {
        return this.state.unlocked ? (this.props.text_unlocked || 'UNLOCKED') : (this.props.text || 'SLIDE')
    }

    reset = () => {

        console.log("reset");
        if (this.unmounted) return;
        this.setState({ unlocked: false }, () => {
            this.sliderLeft = 0;
            this.updateSliderStyle();
        });
    }

    componentWillUnmount() {
        this.unmounted = true;

        console.log("componentWillUnmount:");
        window.removeEventListener('mousemove', this.onDrag);
        window.removeEventListener('mouseup', this.stopDrag);
        window.removeEventListener('touchmove', this.onDrag);
        window.removeEventListener('touchend', this.stopDrag);
    }

    render() {
        return (
            <div className='ReactSwipeButton'>
                <div className={'rsbContainer ' + (this.state.unlocked ? 'rsbContainerUnlocked' : '')} ref={container}>
                    <div className='rsbcSlider'
                        ref={slider}
                        onMouseDown={this.startDrag}
                        style={{ background: this.props.color }}
                        onTouchStart={this.startDrag}>
                        <span className='rsbcSliderText text-30 text-bold'>
                            {this.getText()}

                            {this.state.unlocked &&
                                <span className='m-2 loading-btn'>
                                    <img src='/assets/icons/loading.svg' width='24' height='24' />
                                </span>
                            }

                        </span>
                        <span className='rsbcSliderArrow'></span>
                        <span className='rsbcSliderArrow rsbcSliderArrow-2'></span>
                        <span className='rsbcSliderCircle' style={{ background: this.props.color }}></span>
                    </div>
                    <div className='rsbcText text-30 text-bold'><span className='rsbcText text-40 '>{this.getText()}</span>


                    </div>
                </div>
            </div>
        )
    }
}